import axios from 'axios';
import apiConfig from '../../api.config';
import constants from '../../../constants';
import storage from '../../../storage';

export default function deleteHotelInvoice(invoice) {
  const {
    host,
    URIs: { deleteHotelInvoice },
  } = apiConfig;

  const uri = `${host}${deleteHotelInvoice}`.replace(':hotelInvoiceId', invoice.id);

  const storedCredentials = JSON.parse(storage.get(constants.AUTH.USER_KEY));

  return axios
    .delete(uri, {
      data: {
        accessToken: storedCredentials.accessToken,
        hotelReference: 'civitfun',
      }
    })
    .then(res => {
      return res.data;
    });
}
